import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MonitoredApp from "./MonitoredApp";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MonitoredApp appName={'marketplace'}/>
  </React.StrictMode>
);

